module.exports = __webpack_public_path__ + "PSicon.png?e8b2ba81e9bad1aa685394347a3f0eaa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/PSicon.png
// module id = 48
// module chunks = 0